import { Component } from '@angular/core';
import { formatDate } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FuncsService } from '../services/funcs.service';
import { CustomerCurrent } from '../data/customer';
import { Dealer, DealerCurrent } from '../data/dealer';
import { FleetBillingDetails } from '../data/fleet-billing-details';
import { AccountInfoService } from '../services/account.service';

@Component({
  selector: 'app-fleet-billing-details',
  templateUrl: './fleet-billing-details.component.html',
  styleUrl: './fleet-billing-details.component.css',
  standalone: false
})
export class FleetBillingDetailsComponent {

  errormsg: string = "";
  msg: string = "";

  dealer: Dealer = DealerCurrent;
  fleetDetails: Partial<FleetBillingDetails> = {};
  ref: any;
  fleet: boolean = false;
  dlr: boolean = false;
  international: boolean = false;
  admin: boolean = false;

  billingType: string[] = ['annual', 'monthly'];
  selectedBillingType: string = "";
  isButtonDisabled = false;
  agreementSelection: boolean = false;

  username = "";

  constructor(
    private funcs: FuncsService,
    private route: ActivatedRoute,
    private fleetService: AccountInfoService
  ) { }

  ngOnInit(): void {
    this.msg = "";
    this.errormsg = "";

    this.route.queryParamMap.subscribe(queryParams => {
      this.ref = queryParams.get('ref');
      if (this.ref == "fleet") {
        this.fleet = true;
      } else if (this.ref == "dealer") {
        this.dlr = true;
      } else if (this.ref == "international") {
        this.international = true;
      }
    });
    
    if (this.fleet || this.dlr || this.international) {
      this.funcs.currentDealer(this.dealer);
      this.username = this.getUsername(this.dealer.pa_code);
    } else {
      this.funcs.checkAdmin();
      this.funcs.currentCustomer(CustomerCurrent);
      this.username = CustomerCurrent.username;
    }

    this.admin = this.funcs.isAdmin();

    this.getFleetDetails(this.username);

  }

  getUsername(pa_code: string): string {
    var country = this.funcs.getThreeLetterCountry(pa_code);
    if (country == "USA" || country == "CAN") {
      pa_code = pa_code.slice(3);
    }
    var username = "";
    if (this.fleet) {
      username = `FIN${pa_code}`;
    } else if (this.dlr || this.international) {
      username = `FCT${pa_code}`;
    }

    return username;
  }

  transform(value: string): string {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  getFleetDetails(username: string) {
    this.fleetService.getFleetDetails(username).subscribe(details => {
      this.fleetDetails = details

      this.isButtonDisabled = this.fleetDetails.userName === username;
      
      this.selectedBillingType = this.fleetDetails.billingType || "";

      if(this.selectedBillingType == "annual") {
        this.agreementSelection = true;
      }

      this.fleetDetails.notes = this.fleetDetails.notes ?? "";

      if (this.fleetDetails.optInDate != null) {
        this.fleetDetails.optInDate = formatDate(this.fleetDetails.optInDate, 'yyyy-MM-dd', 'en-US');
      }
    })
  }
  
  updateDetails() {
    this.msg = "";
    this.errormsg = "";

    if (this.selectedBillingType === "") {
      this.errormsg = "Select Billing Type";
      return;
    }

    if (this.fleetDetails.optInDate === "") {
      this.errormsg = "Select Opt-In Date";
      return;
    }

    if(this.selectedBillingType == "annual" && !this.agreementSelection) {
      this.errormsg = "You should agree to billing terms before updating.";
      return;
    }

    this.fleetDetails.userName = this.username;
    this.fleetDetails.billingType = this.selectedBillingType;
    
    const details = this.fleetDetails as FleetBillingDetails;

    this.fleetService.updateFleetBillingDetails(details, CustomerCurrent.username).subscribe(result => {
      if (result) {
        this.msg = "details updated.";
        if(!this.admin) {
          this.isButtonDisabled = true;
        }
      } else {
        this.errormsg = "Update Failed.";
      }
    });

  }

}
